import React, { Suspense } from "react";
import { Spin } from "antd";
const AppVersionsContainer = React.lazy(
  () => import("../../../modules/AppVersions/components/index")
);

const AppManagementPage = () => (
  <Suspense fallback={<Spin />}>
    <AppVersionsContainer />
  </Suspense>
);

export default AppManagementPage;
